import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setTaskListFilterParams } from "../../../../../business/redux/reducers/filter/actions";
import { closeModal } from "../../../../../business/redux/reducers/modal/actions";
import { Box, Badge, Typography, Stack, Button } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { FilterTabs } from "./filterTabs";
import { getTaskList } from "../../../../../business/redux/reducers/taskReducer/actions";

export const TaskListFilterContent = () => {
  const dispatch = useDispatch();

  const { taskListFilterParams } = useSelector((s) => s.filters);

  const filterCount = Object.keys(taskListFilterParams).reduce((acc, curr) => {
    return Array.isArray(taskListFilterParams[curr])
      ? acc + Number(!!taskListFilterParams[curr].length)
      : acc + Number(!!taskListFilterParams[curr]);
  }, 0);

  return (
    <>
      <Box
        className="modal-title"
        sx={{ p: 3 }}
        direction="row"
        display="flex"
        justifyContent="space-between"
      >
        <Badge
          badgeContent={filterCount}
          color="primary"
          sx={{ mr: 2 }}
          className="count_shadow"
        >
          <Typography
            variant="h1"
            component="div"
            fontWeight="700"
            color="#2B3033"
          >
            Filters
          </Typography>
        </Badge>
        <Button
          variant="outlined"
          color="error"
          className="remove_all_filters"
          sx={{ py: 0 }}
          startIcon={<HighlightOffIcon />}
          onClick={() => dispatch(setTaskListFilterParams({}))}
        >
          Remove All Filters
        </Button>
      </Box>

      <FilterTabs />

      <Stack
        className="modal-footer"
        sx={{ py: "10px", px: 2 }}
        display="flex"
        direction="row"
        justifyContent="space-between"
      >
        <Button
          onClick={() => dispatch(closeModal())}
          variant="contained"
          className="cancle_modal_btn"
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            dispatch(closeModal()).then((r) => r);
            dispatch(getTaskList({ filterFormData: taskListFilterParams }));
          }}
          variant="contained"
          className="view_results_btn active"
        >
          View Results
        </Button>
      </Stack>
    </>
  );
};
